import React, { memo, useMemo } from "react";
import { Helmet } from "react-helmet";
import GoogleOptimize from "../../libs/vendors/google-optimize";

interface IGoogleOptimizeHead {
    isBcpTheme: boolean;
}

const GoogleOptimizeHead = (props: IGoogleOptimizeHead) => {
    const optaContainerId = useMemo(
        () => GoogleOptimize.getOptaContainerId(props.isBcpTheme),
        [props.isBcpTheme]
    );

    return (
        <>
            {optaContainerId ? (
                <Helmet>
                    <style data-testid="go-style" type="text/css">
                        {GoogleOptimize.getStyleAntiFlicker()}
                    </style>
                    <script
                        async
                        defer
                        data-testid="go-anti-flicker"
                        type="text/javascript"
                    >
                        {GoogleOptimize.getScriptAntiFlicker(optaContainerId)}
                    </script>
                    <script
                        async
                        defer
                        data-testid="go-lib"
                        src={GoogleOptimize.getSrcByOptaContainerId(
                            optaContainerId
                        )}
                    />
                </Helmet>
            ) : (
                ""
            )}
        </>
    );
};

export default memo(GoogleOptimizeHead);
